import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DescriptionWrapper,
  DescriptionHeader,
  DescriptionTitle,
  DescriptionContent,
  Content,
  LinkMeeting,
  DescriptionText,
  SelectedUsers,
  TitleDescription,
  TotalParticipes,
  ListWrapper,
  TagSeparator,
  DotSeparator,
  DashSeparator,
} from './styles';
import i18n from 'i18next';
import { formatDateUtc } from '../../../../lib/utils';
import { Tag, Spinner } from 'lego-dist';
import Icons from '../../../../images/icons';

const { Repeat } = Icons;

const EVENT_LABEL: any = {
  student: 'calendar_events:STUDENTS',
  classroom: 'calendar_events:FORM.CLASSROOMS',
  center: 'calendar_events:CENTERS',
};

const EventBodyModal = (props: any) => {
  const { event, participantHooks } = props;
  const { isFetching, data: participants } = participantHooks;
  const [t] = useTranslation();
  const formatHour = i18n.language === 'pt' ? 'HH:mm' : 'hh:mm a';
  const formattedDate = i18n.language === 'en' ? 'MMMM/DD/YYYY' : 'DD/MMMM/YYYY';
  const { description, location, type, video_conferencing: videoConferencing } = event;
  //const isUpdatedBeforeMigration = moment(event.updated_at).isBefore('2022-01-06T16:00:00.000000Z');

  const Participants = useMemo(() => (
    isFetching ? (
      <>
        <Spinner
          loading
          name="threedots"
          position="relative"
          bgColor="transparent"
        />
      </>
    )
      : (
        <ListWrapper>
          {participants.map((item: any, index: number) => (
            <TagSeparator key={index}>
              <Tag
                onClick={() => { }}
                label={item.name}
                iconName=""
                iconColor=""
                className=""
                isActive={false}
                isDeletable={false}
              />
            </TagSeparator>
          ))}
        </ListWrapper>
      )
  ), [isFetching, participants]);

  return (
    <div>
      <DescriptionWrapper>
        <DescriptionHeader>
          <DescriptionTitle>
            {t('calendar_events:RECURRENT_EVENTS.EVENT_DURATION')}
          </DescriptionTitle>
        </DescriptionHeader>

        {event.multiple_days && (
          <DescriptionContent>
            <Content>
              {formatDateUtc(event.started_at, formattedDate)}
              {', '}
              {event.all_day ? t('calendar_events:ALL_DAY') : formatDateUtc(event.started_at, formatHour) }
            </Content>
            <DashSeparator> - </DashSeparator>
            <Content>
              {formatDateUtc(event.finished_at, formattedDate)}
              {', '}
              {event.all_day ? t('calendar_events:ALL_DAY') : formatDateUtc(event.finished_at, formatHour) }
            </Content>
          </DescriptionContent>
        )}

        {!event.multiple_days && (
          <DescriptionContent>
            <Content>
              {formatDateUtc(event.started_at, formattedDate)}
            </Content>
            <DotSeparator> . </DotSeparator>
            <Content>
              {event.all_day ? t('calendar_events:ALL_DAY') :  formatDateUtc(event.started_at, formatHour) }
            </Content>
            {!event.all_day && (
              <div style={{ display: 'flex' }}>
                <DashSeparator> - </DashSeparator>
                <Content>
                  {event.all_day ? t('calendar_events:ALL_DAY') : formatDateUtc(event.finished_at, formatHour) }
                </Content>
              </div>
            )}
          </DescriptionContent>
        )}
      </DescriptionWrapper>

      {event.humanReadableRecurrence && (
        <DescriptionWrapper>
          <DescriptionHeader>
            <DescriptionTitle>
              {t('calendar_events:RECURRENT_EVENTS.RECURRENCE')}
            </DescriptionTitle>
          </DescriptionHeader>
          <DescriptionContent>
            <Repeat style={{ marginRight: '10px' }} />
            <Content style={{ fontStyle: 'italic', wordBreak: 'break-word' }}>{event.humanReadableRecurrence}</Content>
          </DescriptionContent>
        </DescriptionWrapper>
      )}

      {event.location && (
        <DescriptionWrapper>
          <DescriptionHeader>
            <DescriptionTitle>{t('calendar_events:LOCATION')}</DescriptionTitle>
          </DescriptionHeader>
          <DescriptionContent>
            <Content>{location}</Content>
          </DescriptionContent>
        </DescriptionWrapper>
      )}

      {videoConferencing[0] ? (
        <DescriptionWrapper>
          <DescriptionHeader>
            <DescriptionTitle>
              {t('calendar_events:FORM.MEETING_LINK')}
            </DescriptionTitle>
          </DescriptionHeader>
          <DescriptionContent>
            <LinkMeeting
              href={event.video_conferencing[0]?.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {event.video_conferencing[0]?.url}
            </LinkMeeting>
          </DescriptionContent>
        </DescriptionWrapper>
      ) : null}

      {description && (
        <DescriptionWrapper>
          <DescriptionHeader>
            <DescriptionTitle>
              {t('calendar_events:FORM.DESCRIPTION')}
            </DescriptionTitle>
          </DescriptionHeader>
          <DescriptionContent>
            <DescriptionText dangerouslySetInnerHTML={{ __html: description }} />
          </DescriptionContent>
        </DescriptionWrapper>
      )}

      <SelectedUsers>
        <TitleDescription>
          <DescriptionTitle>{t(EVENT_LABEL[type])}</DescriptionTitle>
          <TotalParticipes>
            {t('calendar_events:SELECTED_ITEMS', {
              total: participants?.length,
              items: participants?.length,
              entity: '',
            })}
          </TotalParticipes>
        </TitleDescription>
        {Participants}

      </SelectedUsers>
    </div>
  );
};

export default EventBodyModal;
